module.exports = __webpack_public_path__ + "static/media/image_91.7179ddb6.png";